import { resolvePath, useLocation, useParams } from 'react-router';
import React from 'react';
import Header from 'shared/components/Header/Header';
import { Text } from 'shared/components/Text/Text';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useGetFAQs } from 'api/faqs';
import pages from 'pages';
import LoadingLogo from 'shared/components/Modal/LoadingLogo';
import NoMatch from 'shared/components/NoMatch/NoMatch';
import { QuestionPageWrapper } from './QuestionPage.styles';

export function QuestionPage() {
  const { t } = useTranslation();
  const theme = useTheme();
  const { faqId } = useParams();
  const { state } = useLocation();
  const [originTitle, originPath] = [state?.originTitle, state?.originPath];

  const { data: faqs, isLoading } = useGetFAQs();
  const displayFaq = faqs?.find((faq) => faq.id === faqId);

  if (isLoading) return <LoadingLogo />;
  if (!displayFaq) return <NoMatch />;

  const [baseCrumb, endCrumb] = [
    {
      label: t('support&FAQs.support', { keyPrefix: '' }),
      link: resolvePath(pages.SUPPORT),
    },
    { label: displayFaq.question },
  ];

  const breadCrumbs =
    originTitle && originPath
      ? [baseCrumb, { label: originTitle, link: originPath }, endCrumb]
      : [baseCrumb, endCrumb];

  return (
    <QuestionPageWrapper>
      <Header pageName="FAQ_QUESTION" title={displayFaq.question} routeBreadCrumbs={breadCrumbs} />
      <Text as="p" color={theme.colors.textSecondaryGrey90}>
        {displayFaq.answer}
      </Text>
    </QuestionPageWrapper>
  );
}

export default QuestionPage;
